import { validatorInvoice } from "../../../companies/invoices";
import { validatorClient } from "../../../companies/clients";
import { validatorUsers } from "../../../system/users";
import type { DomainGroup, TableScope } from "../types";
import { validatorDebitNote } from "../../../companies/debit_notes";
import { debitNotesConfigurationValidator } from "../../../companies/debit_notes/configuration";

export const DEBIT_NOTE_STATUSES = ["draft", "issued", "voided"] as const;
export const DEBIT_NOTE_REASONS = [
  "extra_charge",
  "price_adjustment",
  "correction",
  "freight",
  "other",
] as const;

export const debitNotesDomain: DomainGroup = {
  id: "debit_notes",
  name: "Notas de Debito",
  description: "Gestion de notas de debito fiscales",
  icon: "FileUp",
  order: 21,
  status: "active",
  // Solo navegación: se muestra bajo el grupo "Facturación". Permisos y tablas
  // siguen en este dominio.
  navParentGroup: "invoices",
  i18n: {
    namespace: "debit_notes",
    keys: {
      title: "debit_notes.title",
      description: "debit_notes.description",
    },
  },
  modules: [
    {
      id: "debit_notes",
      name: "Notas de Debito",
      description: "Emision y gestion de notas de debito",
      icon: "FileUp",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/invoices/debit-notes"],
      navigation: {
        showInNav: true,
        contexts: ["main", "billing"],
        navOrder: { main: 7, billing: 8 },
        status: "active",
      },
      i18n: {
        namespace: "debit_notes",
        keys: {
          title: "debit_notes.title",
          description: "debit_notes.description",
          longDescription: "debit_notes.longDescription",
          searchPlaceholder: "debit_notes.searchPlaceholder",
          emptyState: "debit_notes.emptyState",
          actions: {
            create: "debit_notes.actions.create",
            edit: "debit_notes.actions.edit",
            delete: "debit_notes.actions.delete",
            view: "debit_notes.actions.view",
          },
        },
        translatableFields: ["notes"],
        translatableEnums: [
          { field: "status", values: DEBIT_NOTE_STATUSES },
          { field: "reason", values: DEBIT_NOTE_REASONS },
        ],
      },
      tables: [
        {
          tableName: "debit_notes",
          schema: validatorDebitNote,
          scope: "branch" as TableScope,
          relations: [
            { key: "invoice", schema: validatorInvoice, tableName: "invoices" },
            {
              key: "client",
              schema: validatorClient,
              tableName: "clients",
              searchableFields: ["name", "contactPerson"],
            },
            {
              key: "lastUpdatedBy",
              sourceField: "internalControl.updatedBy",
              schema: validatorUsers,
              tableName: "users",
            },
            {
              key: "lastCreatedBy",
              sourceField: "internalControl.createdBy",
              schema: validatorUsers,
              tableName: "users",
            },
          ],
          searchFields: ["correlative", "notes"],
          hasStatusIndex: true,
          customRules: [],
        },
      ],
      readOnlyTables: [{ tableName: "invoices" }, { tableName: "clients" }],
    },
    {
      id: "debit_notes_configurations",
      name: "Notas de Debito",
      description: "Configuracion de correlativos para notas de debito",
      icon: "Settings",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/settings/invoices/debit-notes"],
      navigation: {
        showInNav: false,
        contexts: ["settings"],
        navOrder: 5,
        status: "active",
      },
      i18n: {
        namespace: "debit_notes.debit_notes_configurations",
        keys: {
          title: "debit_notes.debit_notes_configurations.title",
          description: "debit_notes.debit_notes_configurations.description",
          longDescription:
            "debit_notes.debit_notes_configurations.longDescription",
          searchPlaceholder:
            "debit_notes.debit_notes_configurations.searchPlaceholder",
          emptyState: "debit_notes.debit_notes_configurations.emptyState",
          actions: {
            create: "debit_notes.debit_notes_configurations.actions.create",
            edit: "debit_notes.debit_notes_configurations.actions.edit",
            delete: "debit_notes.debit_notes_configurations.actions.delete",
            view: "debit_notes.debit_notes_configurations.actions.view",
          },
        },
        translatableFields: [],
        translatableEnums: [],
      },
      tables: [
        {
          tableName: "debit_notes_configurations",
          schema: debitNotesConfigurationValidator,
          scope: "branch" as TableScope,
          relations: [],
          searchFields: [],
          hasStatusIndex: false,
          customRules: [],
        },
      ],
      readOnlyTables: [{ tableName: "correlatives" }],
    },
  ],
};
